document.querySelectorAll('details').forEach(detail => {
  const trigger = detail.querySelector('.header__menu-item');

  if (trigger) {
    detail.addEventListener('mouseenter', () => {
      detail.setAttribute('open', '');
    });

    detail.addEventListener('mouseleave', () => {
      detail.removeAttribute('open');
    });
  }
});
